import { useRef } from "react";
import _ from "lodash";
import { useNavigate } from "react-router";
import {
  tableEntryStyle,
  tableFirstColStyle,
} from "../../components/TableComponent";

import { formatToReadableNumber } from "../../utils/currencyRoboto";

export function BeneficiaryNameRender(data: any) {
  const onClickBeneficiaryName = data.onClickBeneficiaryName;
  const bInvestorId = data.data.bInvestorId;

  const handleClick = () => {
    if (onClickBeneficiaryName && bInvestorId) {
      onClickBeneficiaryName(bInvestorId);
    }
  };

  return (
    <div className="whitespace-nowrap pt-2">
      <p
        className={`${tableEntryStyle} ${
          onClickBeneficiaryName
            ? "cursor-pointer text-blue-600 hover:text-blue-800 hover:underline"
            : ""
        }`}
        onClick={handleClick}
      >
        {data.data.beneficiaryName}
      </p>
    </div>
  );
}

export function SecurityClassRender(data: any) {
  return (
    <div className="whitespace-nowrap pt-2">
      <p className={tableEntryStyle}>{data.data.securityClass}</p>
    </div>
  );
}

export function NumberOfSharesRender(data: any) {
  return (
    <div className="whitespace-nowrap pt-2">
      <p className={tableEntryStyle}>
        {formatToReadableNumber({
          value: data.data?.numberOfShares,
          format: data.data.currencyType,
        })}
      </p>
    </div>
  );
}

export function HoldingPercentageRender(data: any) {
  return (
    <div className="whitespace-nowrap pt-1">
      {formatToReadableNumber({
        value: data.data?.holdingPercentage,
        format: data.data.currencyType,
      })}
    </div>
  );
}

export function EmailRender(data: any) {
  return (
    <div className="whitespace-nowrap pt-2">
      <p className={tableEntryStyle}>{data.data.email || "-"}</p>
    </div>
  );
}

export function AddressRender(data: any) {
  return (
    <div className="whitespace-normal pt-2 max-w-xs">
      <p className={tableEntryStyle}>{data.data.address || "-"}</p>
    </div>
  );
}

export function DateRender(data: any) {
  const formatDate = (dateString: string) => {
    if (!dateString) return "-";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString();
    } catch (error) {
      return dateString;
    }
  };

  return (
    <div className="whitespace-nowrap pt-2">
      <p className={tableEntryStyle}>{formatDate(data.data.date)}</p>
    </div>
  );
}
